import {CoOwnerState} from './owner-data/co-owner.model';

export class CalculationState {

  coOwnersState: CoOwnerState[];

  constructor() {
    this.coOwnersState = [];
  }
}
